$(document).ready(function(){
    $('.AnnouncementBar__Wrapper').on('init', function(event, slick){
        $('#shopify-section-announcement .AnnouncementBar__Content').show();
    });


    $('.AnnouncementBar__Wrapper').slick({
        arrows: false,
        infinite: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 2000,      
    })

    var checkEmtywishlist = setInterval(function() {
        var $item = $('.swym-empty-wishlist-container');
        var $item2 = $('.swym-product-final-price');
        if($item.data('translate') != 'true'){
            if ($item.length) {
                $('.swym-empty-wishlist-title.swym-heading.swym-heading-1').text('お気に入りリストに追加');
                $('.swym-empty-wishlist-text.swym-text.swym-text-1').text('お気に入りリストに商品を追加いただくと、もう一度商品を購入される際などに便利です。商品画像の右上にある星印をクリックしてお気に入りに追加ください。');
                $('.swym-empty-wishlist-continue-btn.swym-button.swym-button-1.swym-is-button.swym-bg-2.swym-color-4').text('買い物を続ける');
            }
            $item.attr('data-translate','true');
        }
        // if($item2.data('remove') != true){
        //     if ($item2.length) {
        //         $item2.each(function(){
        //             let result = $(this).text().split('¥');
        //             let number = parseInt(result[1]);
        //             // let vat = number * 0.1;
        //             // let final = number + vat;
        //             // $item2.text((new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(number)));
        //             let numberFormat = new Intl.NumberFormat('en-US').format(number);
        //             $(this).text('¥' + numberFormat);
        //         })
        //     }
        //     $item2.attr('data-remove','true');
        // } else {
        //     if ($item2.length) {
        //         $item2.each(function(){
        //             let result = $(this).text().split('¥');
        //             // let number = parseInt(result[1]);
        //             // let vat = number * 0.1;
        //             // let final = number + vat;
        //             // $item2.text((new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(number)));
        //             // let numberFormat = new Intl.NumberFormat('en-US').format(number);
        //             $(this).text('¥' + result[1]);
        //         })
        //     }
        // }
    }, 200); // check every 500ms

    if($('.SignUp').length > 0){
        var checkEmtyInputSignUp = setInterval(function(){
            if($('input[name="first_name"]').val() != '' && $('input[name="last_name"]').val() != '' 
            && $('input[name="password"]').val() != '' && $('input[name="email"]').val() != '' 
            && $('input[name="gender"]').is(':checked') 
            && $('.input-full option:selected').attr('label') != ''
            &&  $('.input-full option:selected').attr('label') != undefined
            ){
                $('.SignUp .Form__Legend').hide();
            } else {
                $('.SignUp .Form__Legend').show();
            }
        },200)
    }
  
  
    if($('.shopify-section-cart-template').length > 0){
        var checkCheckedInputDelivery = setInterval(function(){
            if($('#delivery-date-boolean-true').is(':checked')){
                $('#delivery-date').css('display','block');
            } else {
                $('#delivery-date').css('display','none');
            }
        },100)
    }

    if($('.customer-edit').length > 0){
        $('.Form__Header').attr('data-change',false);
        var checkTemplateEdit = setInterval(function(){
            if($('.Form__Header').data('change') == false ){
                $('.Form__Header .Form__Title').text('My Account');
                $('.Form__Header .Form__Legend').text('変更されたい項目をご入力いただき「アカウント情報を変更する」ボタンを押してください。');
                $('.Form__Header').attr('data-change',true);
                clearInterval(checkTemplateEdit);
            }
        },100)
    }

    if($('.shopify-section-product-template').length > 0){
        var checkbtnSoldOut = setInterval(function(){
            if($('#BIS_trigger').length > 0){
                $('.ProductForm__AddToCart[disabled="disabled"]').hide();
            }
        },100)
    }

    $('.HorizontalList__Item label').click(function(){
      setTimeout(function() {
         $('.ProductForm__AddToCart').show();
        if($('.ProductForm__AddToCart').attr('disabled') == 'disabled'){
          console.log($('.ProductForm__AddToCart').attr('disabled') == 'disabled');
          $('.ProductForm__AddToCart').hide();
        } else {
          $('.ProductForm__AddToCart').show();
        }
      }, 0);
    })
})